import { SectorTableData } from './SectorTable.component';
import SecondLevelTable from './SecondLevelTable.component';
import { UnfoldLess } from '@mui/icons-material';

const SecondLevelTableWrapper = () => [
  (rowData: SectorTableData) => {
    const render = () => (
      <SecondLevelTable
        title={'Underling Assets'}
        data={rowData.underlyingAssets}
      />
    );
    return {
      openIcon: UnfoldLess,
      render,
      disabled: rowData.underlyingAssets.length ? false : true,
    };
  },
];

export default SecondLevelTableWrapper;
